import React from 'react';
import styled from 'styled-components';
import { Box, Grid } from '@material-ui/core';
import { ChevronRight } from 'react-feather';

export const ItemsWrapper = styled(
  ({
    backgroundColor,
    borderColor,
    borderRadius,
    deleteHoverBorder,
    ...otherProps
  }) => <Box {...otherProps} />,
)`
  border-radius: ${(props) => props.borderRadius || '10px'};
  border: 1px solid;
  border-color: ${(props) => props.borderColor || `#C2D1D9`};
  background-color: ${(props) => props.backgroundColor || `#fff`};
  box-sizing: border-box;
  height: 100%;
  &: hover {
    opacity: 0.9;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.12);
    cursor: pointer;
    border: ${({ deleteHoverBorder, borderColor }) =>
      deleteHoverBorder ? 'none' : `1px solid ${borderColor}`};
  }
`;

export const ContentWrapper = styled(Grid)`
  padding: 12px 16px;
  box-sizing: border-box;
  height: 100%;
`;

export const StyledChevronRight = styled(({ reverse, ...props }) => (
  <ChevronRight {...props} />
))`
  float: right;
  transform: ${(props) => (props.reverse ? 'scaleX(-1)' : '')};
`;

export const StyledIcon = styled.img`
  height: 24px;
  width: 24px;
`;

export const StyledGrid = styled(Grid)`
  text-align: end;
`;
